//Used for all redux reducers
export interface IAction {
  type: string;
  newState: object;
}

//Used for reduxValidation
export interface IModifyPropertyError {
  reduxObjectName: string;
  propertyName: string;
  errorMessage: string;
}

//Used for reduxNotifications
export interface INotification {
  id: string;
  notificationType: string;
  title: string;
  content: any;
}

//Used for UserInfo (Identity Service)
export interface IUserInfo {
  userId : string;
  userType :string ;
  firstName : string;
  lastName : string;
  email : string;
  officeMembershipsArr : any[];
}

export interface Ierror {
  validationError: string | null;
  modifyPropertyError: string | null;
}
export enum ACCUArrangement {
  SingleCircuitSideBySide_P1,
  SingleCircuitOverUnderTopTunnel_P2,
  TwoCircuitSideBySideL_P3,
  TwoCircuitOverUnderParallel_P4,
  SingleCircuitOverUnderFullHeight_S1,
  TwoCircuitOverUnderFullHeightParallel_S2,
  TwoCircuitSideBySideInSeries_S3,
  SingleCircuitOverUnderExhaust_M1,
  SingleCircuitOverUnderEnd_M2,
  SingleCircuitSideBySideEndTurned_M3,
  SingleCircuitSideBySideEnd_M4,
  TwoCircuitOverUnderExhaustSeries_M5,
  TwoCircuitOverUnderEndSeries_M6,
  TwoCircuitSideBySideEndParallel_M7,
  Automatic = "Automatic",
  SingleCircuitSingleTunnelEnd_P5 = 15,
  SingleCircuitSingleTunnelEndTurned_M8 = 16,
  TwoCircuitSingleTunnelEndParallel_P6 = 17,
  TwoCircuitSingleTunnelEndSeries_M9 = 18,
  ThreeCircuitSingleTunnelT_T1 = 19,
  FourCircuitSingleTunnelEndParallel_F1 = 20,
  ThreeCircuitSideBySide_T2 = 21,
  ThreeCircuitSideBySide_T3 = 22,
  FourCircuitSideBySide_F2 = 23,
  ThreeCircuitOverUnder_T4 = 24,
  FourCircuitOverUnder_F3 = 25,
  SingleCircuitWshpEnd_W1 = 26,
  SingleCircuitWshpEndTurned_W2 = 27,
  SingleCircuitWshpExhaust_W3 = 28,
  TwoCircuitWshpEnd_W4 = 29,
  TwoCircuitWshpEndTurned_W5 = 30,
  TwoCircuitWshpExhaust_W6 = 31,
  ThreeCircuitWshpEndParallel_W7 = 32,
  ThreeCircuitWshpEndSeries_W8 = 33,
  ThreeCircuitWshpExhaust_W9 = 34,
  FourCircuitWshpEndParallel_W10 = 35,
  FourCircuitWshpEndSeries_W11 = 36,
  FourCircuitWshpExhaust_W12 = 37
}
export enum AirTunnelOrientation {
  NotSet = 0,
  Stacked = 1,
  SideBySide = 2,
}
export interface IHeatWheelOption{
  isDefaultSelection: boolean,
  modelNumber: string,
  WheelDiameter: number,
  totalEffectiveness: number,
  summerLAT: number,
  summerWetBulbLAT: number,
  winterLAT: number,
  pressureDrop: number,
  summerSensibleEff: number,
  summerLatentEff: number,
  summerTotalEff: number,
  winterSensibleEff: number,
  winterLatentEff: number,
  winterTotalEff: number
}
export enum SortBy {
  None = 0,
  ASC = 1,
  DESC = 2
}
export enum ProjectStatusFilterBy {
  All = 0,
  Design = 1,
  Bidding = 2,
  Release = 3,
  Submittal = 4,
  Shipped = 5, //not used anymore, leaving in case it was used on an existing project
}
export interface IFactoryRequest{
  ProjectId: string,
  RequestType: string,
  CrmOpportunityId: string,
  SelectedUnits: string[]
}
export interface IDesignRequestDetails {
  Pricing:string,
  BasisOfDesign:string,
  BidDate:string,
  AdditionalEmailRecipients:string[]
}
export interface ISubmittalRequestDetails {
  PurchaseOrderNumber:string,
  ConsultingEngineer:string,
  Contractor:string,
  AdditionalEmailRecipients:string[]
}
export interface IReleaseRequestDetails {
  ShippingDateType:string,
  RequestedDeliveryDate:string,
  NotifyCustomerHours:number,
  WillAdviseShippingAddress:boolean,
  ContactName :string,
  ContactPhoneNumber :string,
  AddressLine1 :string,
  AddressLine2 :string,
  City :string,
  StateRegion :string,
  ZipPostalCode :string,
  CountryRegion :string,
  SpecialNotes :string,
  BillToAccount :string,
  PurchaseOrderNumber :string,
  IsTaxExempt:boolean,
  ConsultingEngineer :string,
  Contractor :string,
  ProjectType :string,
  BuildingType :string,
  ConstructionType :string,
  IsFinalInstallUS:boolean,
  GoodsUsedForWeapons:boolean,
  JobCountry :string
}
export interface IModifications {
  Id:number,
  ModificationType:string,
  Description:string,
  Units:""
}
export interface IUnitDto {
  UnitId:string,
  UnitTag:string,
  OpportunityProductId:string
}